import React from 'react';
import './css/base.css';

// Contexto y Gestor de Modales
import { ModalProvider } from './context/ModalContext';
import ModalManager from './Components/modals/ModalManager';

// Componentes de Layout
import Navbar from './Components/layout/Navbar';
import Footer from './Components/layout/Footer';

// Secciones Principales
import HeroSection from './Components/Sections/HeroSection';
import PacCredentialsSection from './Components/Sections/PacCredentialsSection';
import MissionPillarsSection from './Components/Sections/MissionPillarsSection';
import PacImportanceSection from './Components/Sections/PacImportanceSection';
import TimbradoPromoSection from './Components/Sections/TimbradoPromoSection';
import TimbradoDarkSection from './Components/Sections/TimbradoDarkSection';
import SicaiFamilySection from './Components/Sections/SicaiFamilySection';
import ToolsSection from './Components/Sections/ToolsSection';
import AddendasAndDevSection from './Components/Sections/AddendasAndDevSection';
import ContactSection from './Components/Sections/ContactSection';

function App() {
  return (
    <ModalProvider>
      <div className="df-app-wrapper" id="top">
        {/* Barra de Navegación Responsiva con Drawer Móvil */}
        <Navbar />

        {/* Contenido Principal */}
        <main>
          {/* 1. Hero Principal */}
          <HeroSection />

          {/* 2. Credenciales PAC e ISO */}
          <PacCredentialsSection />

          {/* 3. Misión y 3 Pilares */}
          <MissionPillarsSection />

          {/* 4. Importancia de un PAC */}
          <PacImportanceSection />

          {/* 5. Introducción al Timbrado */}
          <TimbradoPromoSection />

          {/* 6. Timbrado Corporativo & Developers (Tema Oscuro) */}
          <TimbradoDarkSection />

          {/* 7 y 8. Familia SICAI (Web, Pro, Server) */}
          <SicaiFamilySection />

          {/* 9. Herramientas: DeConect y SICAI XML */}
          <ToolsSection />

          {/* 10. Addendas y Desarrollo a la Medida */}
          <AddendasAndDevSection />

          {/* 11. Formulario de Contacto y Canales Directos */}
          <ContactSection />
        </main>

        {/* Pie de Página con Enlaces Legales y Compliance */}
        <Footer />

        {/* Gestor Centralizado de Modales en React Puro */}
        <ModalManager />
      </div>
    </ModalProvider>
  );
}

export default App;
